import { WeeklyActivity, DailyActivity } from '../types/weeklyActivities';

export const DAILY_ACTIVITIES: DailyActivity[] = [
    {
        time: '12pm',
        dailyData: 15
    },
    {
        time: '1am',
        dailyData: 14
    },
    {
        time: '2am',
        dailyData: 24
    },
    {
        time: '3am',
        dailyData: 24
    },
    {
        time: '4am',
        dailyData: 15
    },
    {
        time: '5am',
        dailyData: 15
    },
    {
        time: '6am',
        dailyData: 21
    },
    {
        time: '7am',
        dailyData: 15
    },
    {
        time: '8am',
        dailyData: 14
    },
    {
        time: '9am',
        dailyData: 15
    },
    {
        time: '10am',
        dailyData: 15
    },
    {
        time: '11am',
        dailyData: 11
    },
    {
        time: '12am',
        dailyData: 15
    },
    {
        time: '1pm',
        dailyData: 20
    },
    {
        time: '2pm',
        dailyData: 15
    },
    {
        time: '3pm',
        dailyData: 15
    },
    {
        time: '4pm',
        dailyData: 15
    },
    {
        time: '5pm',
        dailyData: 15
    },
    {
        time: '6pm',
        dailyData: 15
    },
    {
        time: '7pm',
        dailyData: 15
    },
    {
        time: '8pm',
        dailyData: 15
    },
    {
        time: '9pm',
        dailyData: 15
    },
    {
        time: '10pm',
        dailyData: 23
    },
    {
        time: '11pm',
        dailyData: 15
    }
];

export const ACTIVITIES: WeeklyActivity[] = [
    {
        date: 'Today,Nov 6',
        value: 10
    },
    {
        date: 'Tomorrow,Nov 7',
        value: 12
    },
    {
        date: 'Wednesday,Nov 8',
        value: 10
    },
    {
        date: 'Thursday,Nov 9',
        value: 12
    },
    {
        date: 'Friday,Nov 10',
        value: 5
    },
    {
        date: 'Saturday,Nov 11',
        value: 13
    },
    {
        date: 'Sunday,Nov 12',
        value: 16
    },
    {
        date: 'Monday,Nov 13',
        value: 10
    },
    {
        date: 'Tuesday,Nov 14',
        value: 18
    },
    {
        date: 'Wednesday,Nov 15',
        value: 20
    },
    {
        date: 'Thursday,Nov 16',
        value: 12
    },
    {
        date: 'Friday,Nov 17',
        value: 16
    },
    {
        date: 'Saturday,Nov 18',
        value: 13
    },
    {
        date: 'Sunday,Nov 19',
        value: 10
    }
];
